export default {
  backend_url: "https://hackgt2020.herokuapp.com/api/articles",
  popup: {
    settings: 1,
    preferences: 2,
  },
  settings: [
    {
      key: "SRC_RANK",
      defaultValue: 1.5,
    },
    {
      key: "SRC_REP",
      defaultValue: 1,
    },
    {
      key: "SRC_POP",
      defaultValue: 1,
    },
    {
      key: "SRC_BREADTH",
      defaultValue: 0.5,
    },
    {
      key: "SRC_BIAS",
      defaultValue: -1,
    },
    {
      key: "FACTOR_SOURCE",
      defaultValue: 0.6,
    },
    {
      key: "FACTOR_TWITTER",
      name: "Social Media",
      defaultValue: 0.1,
      lowValue: 0,
      highValue: 0.2,
      toggleable: true,
    },
    {
      key: "FACTOR_POLITICAL",
      name: "Political",
      defaultValue: 0.3,
      lowValue: 0,
      highValue: 0.5,
      toggleable: true,
    },
    {
      key: "TWITTER_RATIO_BONUS",
      defaultValue: 0.5,
    },
    {
      key: "TWITTER_RATIO",
      defaultValue: 0.4,
    },
    {
      key: "POLITICAL_BONUS",
      defaultValue: 0.8,
    },
    {
      key: "POLITICAL_SENTIMENT",
      name: "Political Sentiment",
      highLabel: "Higher",
      lowLabel: "Lower",
      defaultValue: -0.2,
      lowValue: -0.5,
      highValue: 0.5,
      toggleable: true,
    },
    {
      key: "TIME_DECAY",
      name: "Recency",
      highLabel: "Newer",
      lowLabel: "Older",
      lowValue: 0,
      highValue: 1.5,
      defaultValue: 0.5,
      toggleable: true,
    },
  ],
};
